/* eslint-env browser */

export default function getBaseUrl () {
  const {location: {protocol, hostname, port}} = window;
  return `${protocol}//${hostname}${(port ? `:${port}` : '')}`;
}
